export const APP_LOAD = "APP_LOAD";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const REDIRECT = "REDIRECT";
export const CLEAR_REDIRECT = "CLEAR_REDIRECT";
